import { ProcessFileType } from '../convert/enums/process-file-type.enum';

export const skipConversionFileTypes = [
  ProcessFileType.XKT,
  ProcessFileType.GLB,
  ProcessFileType.BIM,
  ProcessFileType.LAS,
  ProcessFileType.OBJ,
  ProcessFileType.STL,
];
